import React from "react";
import TinySlider from "tiny-slider-react";
import FeatureCard from "./FeatureCard";

export default function SolucionesIntegradas({ features, settings }) {
  return (
    <>
      <section aria-label="Soluciones integradas 4.0" className="bg-sidom-blue">
        <div className="container">
          <div className="flex flex-col justify-start px-2 md:px-0 lg:px-0">
            <h1 className="text-3xl md:text-[40px] lg:text-[45px] text-left mt-[70px] md:mt-[100px] lg:mt-[90px] px-2 md:px-0 lg:px-0 lg:text-4xl p-1 md:p-1 lg:p-0 font-bold text-sidom-orange dark:text-sidom-light mb-8">
              Soluciones integradas 4.0
            </h1>
          </div>
        </div>
      </section>
      <section className="bg-sidom-blue soluciones-carousel-wrapper">
        <div className="container relative">
          <div className=" px-2 md:px-0 lg:px-0">
            <TinySlider settings={settings}>
              {features.map((feature, index) => (
                <div
                  className="mb-[70px] md:mb-[100px] lg:mb-[90px] px-2 md:px-0 lg:px-0"
                  key={index}
                >
                  <FeatureCard
                    title={feature.title}
                    description={feature.description}
                  />
                </div>
              ))}
            </TinySlider>
          </div>
        </div>
      </section>
    </>
  );
}
